/**  
 * created by panjm on 2019-08-28
 * 
 * description： 头部模块
 * 
 */

import utils from 'libs/utils.js';
import config from 'libs/config.js';
import PageInit from 'libs/init.js';
import http from 'libs/http.js';
import api from 'api';

import HeaderTpl from './module/header.dot';

export default class Header {
	/**  
	 * description： 构造函数
	 * @param {Object} 属性集合 
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	constructor({level} = {level: 1}) {
		// 初始化html容器
		this.headerContainer = $('#header');
		// 解决图片等在不同目录下的地址问题
		this.dpath = utils.getDpath(level);
	}

	/**  
	 * description： 渲染header内容
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	render() {
		// 模版数据
		let data = {
			dpath: this.dpath
		};
		
		// 在页面上添加头部
		this.headerContainer.html(utils.replacePath(HeaderTpl(data)));
		// 事件绑定
		this.bindEvent();
	}
	
	/**
	 * description： 获取用户数据之后刷新html 并获取消息数据
	 * @param {Object} user 用户数据
	 * @param {Object} project 项目信息
	 * @param {String} role 角色信息 
	 *  @param {Object} btnAuths 按钮权限数据
	 * 
	 * created by hezq on 2019-09-09
	 *
	 */
	refreshHTML(user,project,role,btnAuths,isMain){
		if(!user){
			return;
		}
		
		let imgurl = ''
		
		if(user.imgurl) {
			if(user.flag08 === 1) { // 新的文件服务
				if(user.imgurl.substr(0,1) === '/') {
					imgurl = `${config.MS_DOC_PATH}${user.imgurl}`
				} else {
					imgurl = `${config.MS_DOC_PATH}/${user.imgurl}`
				}
			} else { // 老的文件服务
				imgurl = `${config.DOC_PATH}${user.imgurl}`
			}
		}
		
		// 模版数据
		let data = {
			dpath: this.dpath,
			user: user,
			imgurl: imgurl
		};
		
		// 重新渲染，带上用户信息
		this.headerContainer.html(utils.replacePath(HeaderTpl(data)));
		
	}
	
	/**  
	 * description： 事件绑定
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	bindEvent() {
		let that = this;
		
		// 绑定点击退出平台事件
		$('body').on('click', '.loginOut', function(){
			utils.confirm({
				message: '确认退出？',
				success: function(){
					// 开启页面loading效果
					utils.pageLoading();

					const params = {
						url: api.common.doLoginOut,
						type: 'POST'
					};
					
					http.ajax(params, (res) => {
						// 关闭页面loading效果
						utils.unPageLoading();
						// 移除本地缓存
						tools.store.clearSS();
						tools.store.clearLS();
						
						// 跳转到登录页
						utils.loginOut();
					}, err => {
						// 关闭页面loading效果
						utils.unPageLoading();
						// 跳转到登录页
						utils.loginOut();
					});
				}
			});
		});
		
	}
}


// WEBPACK FOOTER //
// ./src/template/dot/layout/header/index.js